export default "__VITE_ASSET__C3bSIvyT__"